import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import time from '/public/home/header/time_s.svg';
import training from '/public/home/header/training_s.svg';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
    },
    blueBttn: {
        width: 194,
        height: 40,
        background: 'white',
        borderRadius: 8,
        marginRight: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
});

const Contact = ({ ...props }) => {
    const classes = useStyles({ windowsize: props.windowsize });

    const coloredSvg = [
        {
            icon: training,
            text: 'Санал хүсэлт илгээх',
            style: {
                lineHeight: '14px',
            },
            isLink: true,
            link: 'https://www.facebook.com/',
        },
        {
            icon: time,
            text: 'Өргөдөл, гомдол гаргах',
            style: {
                lineHeight: '14px',
            },
            isLink: true,
            link: 'https://www.youtube.com/',
        },
    ];

    return (
        <Box
            style={{
                display: 'flex',
                justifyContent: props.windowsize > 700 ? 'unset' : 'end',
                marginTop: 25,
                alignItems: 'center',
            }}
            {...props}
        >
            <>
                {coloredSvg.map((item, ind) => {
                    return (
                        <a legacyBehavior target="_blank" href={item.link} passHref>
                            <div key={ind} className={classes.blueBttn}>
                                <Typography
                                    variant="h6"
                                    style={{
                                        color: '#293398',
                                        lineHeight: '14px',
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </div>
                        </a>
                    );
                })}
            </>
        </Box>
    );
};

Contact.propTypes = {
    className: PropTypes.string,
};

export default Contact;
